import Axios, { AxiosRequestConfig } from 'axios'
import adapter from './app-adapter';

export const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL_USERDATA,
  timeout: 30000,
  headers: {'Content-Type': 'application/json'}
})

export const withoutAuthAxios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL_USERDATA,
  timeout: 30000,
  headers: {'Content-Type': 'application/json'}
})

export const SSOAPI = Axios.create({
  baseURL: process.env.VUE_APP_SSO_URL,
  timeout: 30000,
  headers: {'Content-Type': 'application/json'}
})


export const withoutAuthAxiosWS = Axios.create({
  baseURL: process.env.VUE_APP_API_URL_WS,
  timeout: 30000,
  headers: {'Content-Type': 'application/json'}
})

export const oldBackAxios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
})


export const notifierAPI = Axios.create({
  baseURL: process.env.VUE_APP_NOTIFIER_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json'}
})



export const WPAPI = Axios.create({
  baseURL: 'https://rixtrema.com/blog/wp-json/wp/v2',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
})


try{
  let token = localStorage.getItem('AppToken');
  let fingerPrint = localStorage.getItem('fingerPrint')

  const login = localStorage.getItem('AppLogin');

  const urlParams = new URLSearchParams(window.location.search);
  const tokenFromParams = urlParams.get('token');

  if (tokenFromParams){
    token = tokenFromParams;
    localStorage.setItem('AppToken', token);

    fingerPrint = '111finger111'
    localStorage.setItem('fingerPrint', fingerPrint);

  }
  
  axios.defaults.headers.common['Token'] = token;
  axios.defaults.headers.common['Login'] = login;
  axios.defaults.headers.common['fingerPrint'] = fingerPrint;

  if (window.location.hostname !== 'rixtrema.net' || window.location.href !== 'rixtrema.com') {
    axios.defaults.headers.common['RiXtremaCredentials'] = 'V6JXybJ9bVEWQtwFabQ'
  }

  notifierAPI.defaults.headers.common['Token'] = token;
  notifierAPI.defaults.headers.common['Login'] = login;
  notifierAPI.defaults.headers.common['fingerPrint'] = fingerPrint;

  if (window.location.hostname !== 'rixtrema.net' || window.location.href !== 'rixtrema.com') {
    notifierAPI.defaults.headers.common['RiXtremaCredentials'] = 'V6JXybJ9bVEWQtwFabQ'
  }

  SSOAPI.defaults.headers.common['Token'] = token;
  SSOAPI.defaults.headers.common['Login'] = login;
  SSOAPI.defaults.headers.common['fingerPrint'] = fingerPrint;

  if (window.location.hostname !== 'rixtrema.net' || window.location.href !== 'rixtrema.com') {
    SSOAPI.defaults.headers.common['RiXtremaCredentials'] = 'V6JXybJ9bVEWQtwFabQ'
  }

} catch(err){
  
  window.alert('Please, allow you cookies or use https://rixtrema.net/techmarket')
}






// adapter(axios);
adapter(withoutAuthAxios);
adapter(WPAPI);
adapter(SSOAPI)

export const network = {
  get: <R, Params = {}>(url: string, params?: Params): Promise<R> =>
    axios.get(url, { params }),
  post: <R, Data>(
    url: string,
    data: Data,
    config?: AxiosRequestConfig
  ): Promise<R> => axios.post(url, data, config),
  delete: <R>(url: string): Promise<R> => axios.delete(url),
  patch: <R, Data>(
    url: string,
    data: Data,
    config?: AxiosRequestConfig
  ): Promise<R> => axios.patch(url, data, config)
};